import { FuelTableContainer } from 'pages/FuelManagement/FuelManagement.styled'
import styled from 'styled-components'
import { Box, colors } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'

export const AccommodationRoomsTableContainer = styled(FuelTableContainer)`
  width: 100%;
`

export const AccommodationNotificationContainer = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  transition: 0.2s ease;

  :hover {
    box-shadow: ${tokens.accent.glow};
    outline: 1px solid ${tokens.accent.base};
  }
`

export const CampContainer = styled.div<{ active?: boolean }>`
  ${(props) => props.theme.container};
  width: 100%;
  height: ${(props) => (props.active ? 'fit-content' : '94px')};
  transition: 0.2s ease;
  cursor: pointer;
  overflow: ${(props) => (props.active ? 'visible' : 'hidden')};

  &:hover {
    box-shadow: ${tokens.accent.glow};
    outline: 1px solid ${tokens.accent.base};
  }
`

export const CampOverviewContainer = styled.div`
  ${(props) => props.theme.content};
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-radius: 12px;
`

export const BlockContainer = styled.div`
  padding: 1rem;
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ColoredSquare = styled.div<{ color: string; width?: string }>`
  width: ${(props) => props.width || '32px'};
  aspect-ratio: 1/1;
  background-color: ${(props) => props.color};
  border-radius: 10px;
  display: grid;
  place-items: center;
`

export const StepNumber = styled.div<{ active?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 100%;
  ${(props) => props.active && `border: 1px solid ${tokens.accent.base};`}
  background: ${tokens.surface.base};
  display: grid;
  place-items: center;
  color: ${tokens.accent.base};
  font-size: 16px;
`

export const Container = styled.div`
  width: 100%;
  ${(props) => props.theme.boxContainer};
  overflow: hidden;
`

export const ContainerHeader = styled.div<{ padding?: boolean }>`
  background: ${tokens.surface.glass};
  border-bottom: 1px solid ${tokens.border.hairline};
  border-radius: 0px 16px 0px 0px;
  width: 100%;
  height: 50px;
  display: flex;
  ${(props) => props.padding && 'padding:1rem; height:auto;'}
`

export const ContainerContent = styled.div<{ noHeader?: boolean; gap?: string }>`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.noHeader ? '0rem' : '1rem')};
  height: calc(100% - 50px - 1rem);
  gap: ${(props) => props.gap || '0rem'};
`

export const HeaderButton = styled.div<{ active?: boolean }>`
  width: 100%;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: ${tokens.text.primary};
  font-size: 16px;
  background: ${(props) => (!props.active ? tokens.surface.glass : colors.paleOrange)};
  border-bottom: 1px solid ${tokens.text.muted};
  ${(props) => props.active && `border-bottom: 2px solid ${tokens.accent.base};`}
  border-bottom: 1px solid ${(props) =>
    !props.active ? tokens.border.strong : colors.orange};
`

export const IconContainer = styled.div<{ color?: string }>`
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  background-color: ${(props) => props.color || tokens.text.muted};
  border-radius: 100%;
`

export const SelectedEmployeeImage = styled.div`
  min-width: 40px;
  height: 40px;
  border-radius: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`


export const ConatinerScroll = styled.div`
  overflow: auto;
`

export const GuestCardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 2rem;
`

export const GuestCard = styled(Box)<{ borderColor?: string }>`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  ${(props) => props.borderColor && `border:1px solid ${props.borderColor}`}
`

export const AddAccommodationModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  z-index: 999999;
  /* Rectangle 11 */
  background: rgba(34, 32, 32, 0.3);
  backdrop-filter: blur(13.2px);
`

export const AddAccommodationModalContainer = styled.div`
  height: min(750px, 92vh);
  max-width: 1000px;
  width: min(1000px, 96vw);
  border-radius: ${tokens.radius.card};
  display: flex;
  overflow: hidden;
  background: ${tokens.surface.base};
  border: 1px solid ${tokens.border.strong};
  box-shadow: ${tokens.shadow.card};

  @media (max-width: 768px) {
    flex-direction: column;
    height: min(900px, 95vh);
  }
`

export const AddAccommodationSteps = styled.div`
  padding: 1.75rem 1.5rem;
  background: ${tokens.surface.raised};
  border-right: 1px solid ${tokens.border.hairline};
  width: 300px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0.75rem 1rem;
    border-right: none;
    border-bottom: 1px solid ${tokens.border.hairline};
    flex-shrink: 0;

    > p:first-child {
      font-size: 1rem;
    }

    > p:nth-child(2) {
      display: none;
    }

    > div {
      flex-direction: row !important;
      flex-wrap: nowrap;
      justify-content: space-between;
      gap: 0.5rem !important;
      margin-top: 0.5rem !important;
      overflow-x: auto;

      > div p {
        display: none;
      }
    }
  }
`

export const StepRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  position: relative;
  padding: 0.45rem 0;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    left: 16px;
    top: calc(50% + 18px);
    width: 1px;
    height: calc(100% - 24px);
    background: ${tokens.border.hairline};
  }
`

export const StepLabel = styled.span<{ $active?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${(props) => (props.$active ? 600 : 400)};
  color: ${(props) => (props.$active ? tokens.text.primary : tokens.text.muted)};
  transition: color 0.2s ease;
`

export const AccommodationStep = styled.div<{ active?: boolean; done?: boolean }>`
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 100px;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
  z-index: 1;
  transition: all 0.2s ease;
  ${(props) =>
    props.done
      ? `background: ${tokens.accent.base}; color: ${tokens.accent.ink}; border: 1px solid ${tokens.accent.base};`
      : props.active
        ? `background: ${tokens.accent.soft}; color: ${tokens.accent.base}; border: 1px solid ${tokens.accent.base};`
        : `background: ${tokens.surface.inset}; color: ${tokens.text.muted}; border: 1px solid ${tokens.border.hairline};`}

  svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    font-size: 0.85rem;
  }
`

export const AddAccommodationModalContnet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
  min-width: 0;
  padding: 2rem;
  background: ${tokens.surface.base};
  color: ${tokens.text.primary};
  box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
  overflow: auto;

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
    flex: 1 1 0;
    min-height: 0;
  }
`

export const ModalCloseBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s ease;
  z-index: 2;

  &:hover {
    background: ${tokens.border.hairline};
  }
`

export const RemoveItemBtn = styled.button`
  background: transparent;
  border: none;
  width: 28px;
  height: 28px;
  min-width: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    background: ${tokens.status.danger.bg};
  }
`

export const AddAccommodationModalContentInputs = styled(Box)``

export const SearchField = styled.div`
  .input {
    position: relative;
  }
`

export const AccomodationBlockReveiw = styled.div`
  position: relative;
  padding-left: 1rem;
  display: flex;
  gap: 1rem;

  &::after {
    height: 100%;
    position: absolute;
    content: '';
    width: 3px;
    top: 0;
    left: 0;
    border-radius: 50px;
    background-color: ${tokens.accent.base};
  }
`
